<template>
  <div class="container">
    <div class="main">
      <div class="login-box">
        <div class="title-box-login">
          <span class="title">管理员登陆</span>
        </div>
        <div class="edit-main">
          <div class="edit-box">
            <img
              class="icon"
              src="../assets/images/ic_login_account.png">
            <div class="boder-one"/>
            <input
              class="input"
              v-model="name"
              placeholder="请输入账号" >
          </div>
          <div class="edit-box">
            <img
              class="icon"
              src="../assets/images/ic_login_password.png">
            <div class="boder-one"/>
            <input
              class="input"
              v-model="password"
              type="password"
              placeholder="请输入密码" >
          </div>
          <div class="verify-box">
            <div
              class="edit-box">
              <img
                class="icon"
                src="../assets/images/ic_login_check_code.png">
              <div class="boder-one"/>
              <input
                class="input"
                v-model="inputCode"
                style="width: 0"
                placeholder="请输入验证码"
                maxlength="4" >
            </div>
            <img
              class="img-verify"
              arc="code"
              id="code"
              @click="event().onVerifyImgClicked()">
          </div>
          <el-button
            class="login-btn"
            @click="event().onLogin()">登录
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '@/api/common'
import Utils from '@/jslibs/utils'
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      code: '',
      inputCode: '',
      name: 'admin',
      password: 'admin',
    };
  },

  created() {},

  mounted() {
    this.handler().refreshCode();
  },

  methods: {
    ...mapActions(['getAllArticlelabel', 'getUrlAndTokenOfImageUpload']),
    event() {
      const self = this;
      return {
        onVerifyImgClicked() {
          self.handler().refreshCode();
        },
        onLogin: () => {
          this.network().addlogin()
        },
      };
    },
    network() {
      return {
        /*  getListA() {}, */
        addlogin: async () => {
          if (!this.handler().verifyInput()) return
          const { status, data } = await login({
            account: this.name,
            password: this.password,
          })
          if (status !== 200) return
          Utils.setCookie('X-Access-Token', data.token, 3)// TODO: 先设三天过期
          Utils.setCookie('adminName', data.name, 3) // TODO: 先设三天过期  */
          this.getAllArticlelabel();
          this.getUrlAndTokenOfImageUpload();
          //登录成功跳转到轮播图页面
          this.$router.push('/slideimg-manage')
        },
      };
    },

    handler() {
      const self = this;
      return {
        refreshCode() {
          // eslint-disable-next-line no-undef
          const res = verifyCode();
          const img = document.getElementById('code');
          img.src = res.dataURL;
          self.code = res.code;
        },
        verifyInput: () => {
          if (!this.name || !this.name.trim()) {
            this.$message({
              message: '请输入账号',
              type: 'warning',
            })
            return false
          }
          if (!this.password || !this.password.trim()) {
            this.$message({
              message: '请输入密码',
              type: 'warning',
            })
            return false
          }
          if (!this.inputCode || !this.inputCode.trim()) {
            this.$message({
              message: '请输入验证码',
              type: 'warning',
            })
            return false
          }
          if (this.code.toLowerCase() !== this.inputCode.toLowerCase()) {
            this.$message({
              message: '验证码错误',
              type: 'warning',
            })
            this.refreshCode()
            return false
          }
          return true
        },
      };
    },
  },
  watch: {},
  computed: {},
};
</script>

<style scoped lang="less">
  .container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    .main {
      flex: 1;
      background: url(../assets/images/cms_bg.png) center center fixed;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      .login-box {
        width: 371px;
        height: 341px;
        background-color: #ffffff;
        .title-box-login {
          background-color: #409EFF;
          width: 100%;
          height: 58px;
          span.title {
            margin: 0 21px;
            line-height: 58px;
            font-size: 16px;
            color: #ffffff
          }
        }
        .edit-main{
          padding: 18px 17px 28px;
          .edit-box {
            display: flex;
            align-items: center;
            width: 312px;
            height: 45px;
            margin-bottom: 16px;
            padding: 0 12px;
            border-radius: 3px;
            border:1px solid rgba(32,53,128,0.16);
            img.icon {
              width: 17px;
              margin-right: 14px;
            }
            div.boder-one{
              width:0px;
              height:24px;
              border-left:1px solid rgba(216,221,233,1);
            }
            input.input {
              padding:0 14px;
              flex: 1;
              outline: none;
              border: none;
              font-size: 12px;
            }
          }
          .verify-box {
            position: relative;
            height: 40px;
            width: 336px;
            .edit-box {
              width: 160px;
              float: left;
              display: flex;
              align-items: center;
              height: 40px;
              margin: 0 auto;
              padding: 0 12px;
              border-radius: 3px;
              border:1px solid rgba(32,53,128,0.16);
              img.icon {
                width: 17px;
                margin-right: 14px;
              }
              div.boder-one{
                width:0px;
                height:24px;
                border-left:1px solid rgba(216,221,233,1);
              }
              input.input {
                flex: 1;
                outline: none;
                border: none;
              }
            }
            img#code.img-verify {
              float: left;
              width: 100px;
              height: 40px;
              margin-left: 20px;
            }
          }
          .login-btn {
            margin: 27px auto 28px auto;
            width:336px;
            height:45px;
            background-color: #409EFF;
            border-radius:3px;
            color: #ffffff;
          }
        }
      }
    }
    .foot {
      height: 54px;
      display: flex;
      padding: 27px 0 33px;
      font-size: 14px;
      flex-direction: column;
      align-items: center;
      p:first-child{
        margin: 0;
      }
      p:last-child{
        margin-top: 12px;
      }
    }
  }
</style>
